import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function ElectricalRepairsPage() {
  const serviceData = {
    title: 'Electrical Repairs',
    subtitle: 'Expert Repair Services',
    description: 'From flickering lights to faulty outlets, our experienced electricians diagnose and repair all types of electrical problems. We provide fast, reliable repair services to restore safety and functionality to your electrical system.',
    heroImage: 'https://public.readdy.ai/ai/img_res/3bf3bd2a374a9b8fc3ac1807fdf0bef7.jpg',
    features: [
      {
        icon: 'ri-tools-line',
        title: 'All Repairs',
        description: 'Fix any electrical issue, big or small'
      },
      {
        icon: 'ri-time-line',
        title: 'Same Day Service',
        description: 'Quick response for urgent repairs'
      },
      {
        icon: 'ri-price-tag-3-line',
        title: 'Transparent Pricing',
        description: 'Clear quotes before work begins'
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Guaranteed Work',
        description: 'Lifetime workmanship guarantee'
      }
    ],
    benefits: [
      'Flickering light repairs',
      'Faulty outlet fixes',
      'Circuit breaker repairs',
      'Switch replacements',
      'Wiring fault repairs',
      'Appliance connection issues',
      'Power surge damage repair',
      'Complete safety testing'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Problem Assessment',
        description: 'Identify the issue and its root cause'
      },
      {
        number: '02',
        title: 'Quote Approval',
        description: 'Provide transparent pricing before starting'
      },
      {
        number: '03',
        title: 'Expert Repair',
        description: 'Fix the problem with quality parts'
      },
      {
        number: '04',
        title: 'Testing',
        description: 'Verify proper operation and safety'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}